export const PARTNERS = [
  {
    id: 'CL2',
    name: 'Caesars Rewards Local',
    pointName: 'Reward Credits',
    displayAsCredits: true,
    leapProperties: [
      {
        code: 'MYG',
        outletCode: 'TGV',
        name: 'Trop Casino Greenville',
        logo: 'trop_greenville.svg',
      },
    ],
  },
  {
    id: 'CL3',
    name: 'Caesars Rewards Local',
    pointName: 'Reward Credits',
    displayAsCredits: true,
    leapProperties: [
      {
        code: 'EL1',
        outletCode: 'BNV',
        name: 'Isle of Capri Casino Hotel Boonville',
        logo: 'capri_boonville.svg',
      },
      {
        code: 'EL1',
        outletCode: 'BTN',
        name: 'Isle Casino Hotel Bettendorf',
        logo: 'isle_bettendorf.svg',
      },
      {
        code: 'EL1',
        outletCode: 'WTR',
        name: 'Isle Casino Hotel Waterloo',
        logo: 'isle_waterloo.svg',
      },
    ],
  },
  {
    id: 'CL4',
    name: 'Caesars Rewards Local',
    pointName: 'Reward Credits',
    displayAsCredits: true,
    leapProperties: [
      {
        code: 'IS1',
        outletCode: 'LUL',
        name: 'Isle of Capri Casino Hotel Lula',
        logo: 'capri_lula.svg',
      },
    ],
  },
];

const tierBracketsMYGAndEL1 = {
  GOLD: {name: 'GOLD', minCredits: 0, maxCredits: 4999},
  PLATINUM: {name: 'PLATINUM', minCredits: 5000, maxCredits: 14999},
  DIAMOND: {name: 'DIAMOND', minCredits: 15000, maxCredits: 24999},
  'DIAMOND PLUS': {
    name: 'DIAMOND PLUS',
    minCredits: 25000,
    maxCredits: 74999,
  },
  'DIAMOND ELITE': {name: 'DIAMOND ELITE', minCredits: 75000},
  'SEVEN STARS': {name: 'SEVEN STARS'},
};

const tierBracketsIS1 = {
  'FAN CLUB': {name: 'FAN CLUB', minCredits: 0, maxCredits: 1599},
  SELECT: {name: 'SELECT', minCredits: 1600, maxCredits: 7999},
  GOLD: {name: 'GOLD', minCredits: 8000, maxCredits: 79999},
  PLATINUM: {name: 'PLATINUM', minCredits: 80000},
  MILLIONAIRE: {name: 'MILLIONAIRE'},
};

export const PARTNER_TIER_BRACKETS = {
  MYG: tierBracketsMYGAndEL1,
  IS1: tierBracketsIS1,
  EL1: tierBracketsMYGAndEL1,
};
